import React from 'react';
import { Plus } from 'lucide-react';
import { OpportunityCard } from './OpportunityCard';
interface OpportunityListProps {
  opportunities: any[];
  role: 'brand' | 'organizer';
  onAdd: () => void;
}
export function OpportunityList({
  opportunities,
  role,
  onAdd
}: OpportunityListProps) {
  const accentColor = role === 'brand' ? 'text-cyan-400' : 'text-purple-400';
  const buttonColor = role === 'brand' ? 'bg-cyan-500 hover:bg-cyan-400 text-slate-900' : 'bg-purple-600 hover:bg-purple-500 text-white';
  if (opportunities.length === 0) {
    return <div className="text-center py-12 bg-slate-900/50 border border-slate-800 rounded-2xl border-dashed" data-id="element-394">
        <div className="w-16 h-16 rounded-full bg-slate-800 flex items-center justify-center mx-auto mb-4" data-id="element-395">
          <Plus className={accentColor} size={32} data-id="element-396" />
        </div>
        <h3 className="text-xl font-bold text-white mb-2" data-id="element-397">
          {role === 'brand' ? 'Add your first campaign' : 'Add your first opportunity'}
        </h3>
        <p className="text-slate-400 mb-6 max-w-md mx-auto" data-id="element-398">
          {role === 'brand' ? 'Create a listing for a product or campaign you want to promote to find matching events.' : 'Create a listing for a specific sponsorship package or event to find matching brands.'}
        </p>
        <button onClick={onAdd} className={`px-6 py-3 rounded-full font-bold transition-all flex items-center gap-2 mx-auto ${buttonColor}`} data-id="element-399">
          <Plus size={18} data-id="element-400" /> Add Opportunity
        </button>
      </div>;
  }
  return <div data-id="element-401">
      <div className="flex justify-between items-center mb-6" data-id="element-402">
        <h2 className="text-2xl font-bold text-white" data-id="element-403">My Opportunities</h2>
        <button onClick={onAdd} className={`px-4 py-2 rounded-full font-medium text-sm transition-all flex items-center gap-2 ${buttonColor}`} data-id="element-404">
          <Plus size={16} data-id="element-405" /> Add New
        </button>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-406">
        {opportunities.map((opp, i) => <OpportunityCard key={i} data={opp} role={role} data-id="element-407" />)}
      </div>
    </div>;
}